<div [class.mobile]="isMobile">
  <h2 mat-dialog-title id="productNotificationTitle">{{ appStrings.products_notificationTitle }}</h2>
  <div mat-dialog-content class="notification-messages">
    @for (message of messages; track $index) {
      @if (message.promoPrice) {
        <div id="productNotificationMessage_{{ $index }}" class="notification-message promotion">
          <p class="promotion-title"><span class="product-name">{{ data.productNumber }}</span>{{ appStrings.promotionTitle }}</p>
          <div class="promotion-details">
            <span>{{ appStrings.promoPriceLabel }}</span>
            <span>{{ message.promoPrice.listPrice | currency: currencySymbol }}</span>
            <span>{{ appStrings.startDate }}</span>
            <span>{{ message.promoPrice.startDate | date: dateFormat }}</span>
            <span>{{ appStrings.endDate }}</span>
            <span>{{ message.promoPrice.endDate | date: dateFormat }}</span>
          </div>
        </div>
      } @else {
        <p id="productNotificationMessage_{{ $index }}" class="notification-message">{{ message.description }}</p>
      }
    }
  </div>
  <div mat-dialog-actions class="notification-buttons">
    @for (button of buttons; track button.action) {
      <button id="productNotificationButton_{{ button.action }}" mat-button class="button"
        [ngClass]="button.isPrimary ? 'primary' : 'mat-button'" (click)="close(button.action)">
        {{ button.label }}
      </button>
    }
  </div>
</div>
